import CaseStudiesSlider from "./CaseStudiesSlider";

const CaseStudiesSliderWithProps = ({ blok }) => {
  return <CaseStudiesSlider sectionTitle={blok.sectionTitle} caseStudies={blok.caseStudies} logos={blok.logos} />;
};

export default CaseStudiesSliderWithProps;
